import React, { useCallback, useEffect, useState } from 'react';
import useApp from 'hooks/useApp';
import SquareBox from 'components/SquareBox';
import Lib from 'library';
import { NoData } from 'components';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { benefitCardLayerShowState, financeCardDetailLayerController, financeLoanDetailState_1, financeLoanDetailState_2, financeLoanDetailState_3, financeSavingDetailState_1, financeSavingDetailState_2, financeSavingDetailState_3, financeProductTypeState } from 'views/recommend/home/states';
import { useNavigate } from 'react-router-dom';
import { keyBnftGrpState } from 'views/recommend/home/BenefitCardDetailLayer';
import { keyCorpsState } from 'views/recommend/home/BenefitCardDetailLayer';
import { keyBnftsState } from 'views/recommend/home/BenefitCardDetailLayer';

const TopTabPane = ({ type, children, title, preSelectedTabIndex }) => {
    const App = useApp();
    const navigate = useNavigate();
    const mbId = App?.user?.mbId || "";

    const setShowBenefitLayer = useSetRecoilState(benefitCardLayerShowState);   // TOP3 - 카드 LIST
    const [keyBnftGrp, setKeyBnftGrp] =useRecoilState(keyBnftGrpState);                 // TOP3 - 카드 필터
    const setShowDetailLayer = useSetRecoilState(financeCardDetailLayerController); // TOP3 - 카드 DETAIL
    const [keyCorps, setKeyCorps] =useRecoilState(keyCorpsState); // 카드회사 선택한 값 초기화
    const [KeyBnftsState, setKeyBnftsState] =useRecoilState(keyBnftsState); // 카드 혜택들(그룹하위) 초기화


    const setSavingDetail_1 = useSetRecoilState(financeSavingDetailState_1);    // TOP3 - 저축 DETAIL(예금)
	const setSavingDetail_2 = useSetRecoilState(financeSavingDetailState_2);    // TOP3 - 저축 DETAIL(적금)
	const setSavingDetail_3 = useSetRecoilState(financeSavingDetailState_3);    // TOP3 - 저축 DETAIL(연금)

    const setLoanDetail_1 = useSetRecoilState(financeLoanDetailState_1);    // TOP3 - 대출 DETAIL(주택)
	const setLoanDetail_2 = useSetRecoilState(financeLoanDetailState_2);    // TOP3 - 대출 DETAIL(전세)
	const setLoanDetail_3 = useSetRecoilState(financeLoanDetailState_3);    // TOP3 - 대출 DETAIL(개인)

    const [subTabList, setSubTabList] = useState();
    const [commonCode, setCommonCode] = useState();
    const [selectedTabIndex, setSelectedTabIndex] = useState(preSelectedTabIndex || 0);
    const [selectedTabType, setSelectedTabType] = useState();
    const [topCard, setTopCard] = useState();   // TOP3 - 카드
    const [topSave, setTopSave] = useState();   // TOP3 - 저축
    const [topLoan, setTopLoan] = useState();   // TOP3 - 대출


	const [productType, setProductType] = useRecoilState(financeProductTypeState) // 세부


    // const getKeyBnftGrp = useCallback((type) => Lib.get(`/api/comm/cd/${type}`, data => setSubTabList(data)), []); // 공통 코드 불러오기

    const getSubTabList = () => {
        console.log("TODO Sub Tab 리스트 가져오기");
        switch(type) {
            case "CARD_BNFT":
                // getKeyBnftGrp(type);
                setSubTabList([
                    {cd_nm: '할인 및 적립', cd_id: 'CRBC1000'},
                    {cd_nm: '교통', cd_id: 'CRBC2000'},
                    {cd_nm: '일상', cd_id: 'CRBC3000'},
                    {cd_nm: '문화생활', cd_id: 'CRBC4000'},
                    {cd_nm: '자녀', cd_id: 'CRBC5000'},
                    {cd_nm: '항공', cd_id: 'CRBC6000'}
                ]);
                break;
            case "SAVING":
                setSubTabList([
                    {
                        cd_id: "deposit",
                        cd_nm: "예금"
                    },
                    {
                        cd_id: "saving",
                        cd_nm: "적금"
                    },
                    {
                        cd_id: "annuity",
                        cd_nm: "연금"
                    },
                ]);
                break;
            case "LOAN":
                setSubTabList([
                    {
                        cd_id: "mortgage",
                        cd_nm: "주택"
                    },
                    {
                        cd_id: "rentHouse",
                        cd_nm: "전세"
                    },
                    {
                        cd_id: "credit",
                        cd_nm: "개인"
                    },
                ]);
                break;
        }
    };

    // 공통코드 호출
    const getCodeList = () => {
        Lib.myGet('/api/auth/sncnApis/v1', data => setCommonCode(data.filter((item) => item.api_nm == '금융상품추천')[0].api_codes))
    }
    const getTopData = (subType = null) => {
        console.log("TODO TOP3 데이터 가져오기", subType);
        switch(type) {
            case "CARD_BNFT":
                // 카드
                Lib.myGet(`/api/recomm/card/v1?page=1&limit=3&cate_grp=${subType}`, data => {
                    console.log('카드데이터 ',data.data)
                    setTopCard(data.data);
                });
                break;
            case "SAVING":
                // 저축
                Lib.myGet(`/api/recomm/${subType}/v1?page=1&limit=3&order_by=-rate`, data => {
                    console.log(subType, '저축데이터 ',data.data)
                    setProductType(subType)
                    setTopSave(data.data);
                });
                break;
            case "LOAN":
                // 대출
                Lib.myGet(`/api/recomm/${subType}/v1?page=1&limit=3&order_by=rate`, data => {
                    console.log(subType, '대출데이터 ',data.data)
                    setProductType(subType)
                    setTopLoan(data.data);
                });
                break;
        }
    };

	// 두 번이상 전체 목록 레이어 오픈 시 공통코드 오류로 useEffect로 확인
	useEffect(() => {
		if(commonCode == undefined){
			getCodeList()
		}
	}, [commonCode]);
	// 혜택 코드 -> 네임으로
	const bnftNameReturn = (code) =>{
		if(commonCode !== undefined){
			return commonCode.filter((item) => item.cd_id == code)[0].cd_nm
		}
			// Lib.myGet('/api/auth/sncnApis/v1', data => {
			// 	// 혜택 공통코드
            //     console.log('22222')
			// 	const codeList = data.filter((item) => item.api_nm == '금융상품추천')[0].api_codes
			// 	return codeList.filter((item) => item.cd_id == code)[0].cd_nm
			// })
		
	};
    const onHandleClick = (e) => {
        const tabType = e.currentTarget.dataset.type
        const tabIndex = e.currentTarget.dataset.index
        if (selectedTabIndex !== parseInt(tabIndex)) {
            setSelectedTabIndex(parseInt(tabIndex));
            setSelectedTabType(tabType);
            getTopData(tabType);
        }
    }

    const onClickMore = () => {
        switch(type) {
            case "CARD_BNFT":
                setKeyBnftGrp(subTabList[selectedTabIndex].cd_id);
                setShowBenefitLayer(true);
                setKeyCorps([])
                setKeyBnftsState([])
                break;
            case "SAVING":
                navigate("/recommend/financeSaving");
                break;
            case "LOAN":
                navigate("/recommend/financeLoan");
                break;
        }
    }

    const financeDetailRouter = (cardId) => {
		// navigate('/recommend/financeCardDetail', { state: { cardId: cardId } });
		setShowDetailLayer({
			show: true,
			cardId: cardId
		})
	};

    const onClickSavingDetail = (item) => {
        console.log('상세데이터 전달', item)
        switch(selectedTabType) {
            case "deposit":
                setSavingDetail_1(prev => ({
                    ...prev,
                    show: true,
                    fdiId: item.fdiId,
                    maxRate2: item.maxRate2,
                }));
                break;
            case "saving":
                setSavingDetail_2(prev => ({
                    ...prev,
                    show: true,
                    fsiId: item.fsiId,
                    maxRate2: item.maxRate2,
                }))
                break;
            case "annuity":
                setSavingDetail_3(prev => ({
                    ...prev,
                    show: true,
                    aniId: item.aniId,
                }))
                break;
        }
    }

    const onClickLoanDetail = (item) => {
        switch(selectedTabType) {
            case "mortgage":
                setLoanDetail_1(prev => ({
                    ...prev,
                    show: true,
                    fmiId: item.fmiId,
                    lendRateMin: item.lendRateMin,
                }))
                break;
            case "rentHouse":
                setLoanDetail_2(prev => ({
                    ...prev,
                    show: true,
                    friId: item.friId,
                    lendRateMin: item.lendRateMin,
                }))
                break;
            case "credit":
                setLoanDetail_3(prev => ({
                    ...prev,
                    show: true,
                    fciId: item.fciId,
                    crdtGradAvg: item.crdtGradAvg,
                }))
                break;
        }
    }

    useEffect(() => {
        if (subTabList && subTabList.length > 0) {
            // SubTab이 없는 경우도 있기 때문에 있을 때만 동작하도록.
            setSelectedTabType(subTabList[selectedTabIndex].cd_id);
            getTopData(subTabList[selectedTabIndex].cd_id);
            console.log(subTabList[selectedTabIndex].cd_id);
        } else if (subTabList && subTabList.length === 0) {
            // 조회를 해왔지만 SubTab이 없는 경우.
            getTopData();
        }
    }, [subTabList]);

    useEffect(() => {
        if (type === "CARD_BNFT") {
            setTopCard();
        }
    }, [selectedTabIndex]);

    useEffect(() => {
        setSelectedTabIndex(0);
        setSelectedTabType();
        getSubTabList();
    }, [type]);

    useEffect(() => {
        // 초기에 한번
        getSubTabList();
        // 공통코드 호출
        getCodeList();
    }, []);


    return (
        <div role="tabpanel">
            <div className="cmm-tab-btn" role="tablist">
                {
                    subTabList && subTabList.map((item, index) => (
                        <button type="button" key={index} data-type={item.cd_id} data-index={index} role="tab" aria-selected={index === selectedTabIndex} onClick={onHandleClick}><span># {item.cd_nm}</span></button>
                    ))
                }
            </div>
            {
                {
                    // 카드
                    CARD_BNFT: <ul className="cmm-list">
                        {
                            topCard ?
                                topCard.length > 0 ?
                                    topCard.map((card, index) =>
                                    <li key={index} onClick={() => financeDetailRouter(card.cardId)}>
                                            <a href="#" className="box">
                                                <i className="img-card"><img src={card.cardImgUrl}/></i>
                                                <span className="txt">{card.cardCoNm}</span>
                                                <span className="tit">{card.cardNm}</span>
                                                <span className="txt">
                                                    {commonCode && card.cardBenefits.filter((item) => item.priority < 3).map((category, index) =>  
                                                        <em key={index}>{`#${bnftNameReturn(category.category)}`}</em>
                                                    )}
                                                </span>
                                            </a>
                                        </li>
                                    )
                                : <NoData />
                            : [...Array(3)].map((item, index) => {
                                return (
                                    <li key={index}>
                                        <div className="box">
                                            <i className="img-card skeleton"><img/></i>
                                            <span className="txt skeleton"></span>
                                            <span className="tit skeleton"></span>
                                            <span className="txt skeleton"><em></em></span>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>,
                    // 저축
                    SAVING: <ul className="cmm-list">
                        {
                            topSave?
                                topSave.length > 0 ?
                                    topSave.map((saving, index) =>
                                        <li key={index} onClick={() => onClickSavingDetail(saving)}>
                                            <a href="#" className="box">
                                                {/* <i src={saving.imgUrl}></i> */}
                                                <span className="txt">{saving.korCoNm}</span>
                                                <span className="tit">{saving.finPrdtNm}</span>
                                                {selectedTabType !== "annuity" && <span className="txt">우대금리 <em>{saving.maxRate2 && Number(saving.maxRate2).toFixed(2)}%</em></span>}
                                                {selectedTabType === "annuity" && <span className="txt">연평균 수익률 <em>{saving.avgPrftRate && Number(saving.avgPrftRate).toFixed(2)}%</em></span>}
                                            </a>
                                        </li>
                                    )
                                : <NoData />
                            : [...Array(3)].map((item, index) => {
                                return (
                                    <li key={index}>
                                        <div className="box">
                                            <span className="txt skeleton"></span>
                                            <span className="tit skeleton"></span>
                                            <span className="txt skeleton"></span>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>,
                    // 대출
                    LOAN: <ul className="cmm-list">
                        {
                            topLoan ?
                                topLoan.length > 0 ?
                                    topLoan.map((loan, index) =>
                                        <li key={index} onClick={() => onClickLoanDetail(loan)}>
                                            <a href="#" className="box">
                                                {/* <i className="icon-bank"></i> */}
                                                <span className="txt">{loan.korCoNm}</span>
                                                <span className="tit">{loan.finPrdtNm}</span>
                                                {selectedTabType !== "credit" && <span className="txt">최저금리 <em>{loan.lendRateMin && Number(loan.lendRateMin).toFixed(2)}%</em></span>}
                                                {selectedTabType === "credit" && <span className="txt">평균 대출 금리 <em>{loan.crdtGradAvg && Number(loan.crdtGradAvg).toFixed(2)}%</em></span>}
                                            </a>
                                        </li>
                                    )
                                : <NoData />
                            : [...Array(3)].map((item, index) => {
                                return (
                                    <li key={index}>
                                        <div className="box">
                                            <span className="txt skeleton"></span>
                                            <span className="tit skeleton"></span>
                                            <span className="txt skeleton"></span>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                }[type]
            }
            <button onClick={onClickMore} className="btn-base-bottom gray"><span>+ 더보기</span></button>
        </div>
    );
};

export default TopTabPane